var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLineChartPreview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 225,
    height: 234,
    viewBox: "0 0 225 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13832_44833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 209L225 209",
    stroke: "#CBCBCB",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 179H225",
    stroke: "#CBCBCB",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 150H225",
    stroke: "#CBCBCB",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 120H225",
    stroke: "#CBCBCB",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 90H225",
    stroke: "#CBCBCB",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 61H225",
    stroke: "#CBCBCB",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 31H225",
    stroke: "#CBCBCB",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 169.39L5.43197 161.691L9.86394 158.138L14.2959 187.156L18.7279 194.855L23.1598 187.748L27.5918 194.855L32.0238 197.816L36.4558 183.603L44.4786 182.418L46.9049 171.166L49.7517 155.769L54.1836 169.982L58.6156 172.351L67.4795 169.39L71.9115 182.418H73.9981L80.7754 199L83.2988 188.34H86.5338L89.6394 196.039L94.0714 175.312L98.5033 188.34L102.935 183.011L107.367 187.748L111.799 194.855L116.231 188.933L120.663 164.06L125.095 174.72L129.527 189.525L132.633 175.312L138.698 164.06L143.551 148.037L147.595 132.032L156.119 122.696H164.983L169.415 116.027L182.371 92.9958L192.076 73.3472L196.929 62.6773H201.781L205.825 48.0061L209.869 41.3374L215.126 34.6687H218.361L222 28",
    stroke: "#373D43",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13832_44833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 225,
    height: 234,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineChartPreview);
export default __webpack_public_path__ + "static/media/lineChartPreview.6af907d7ec0bee96373406ea79f8b52c.svg";
export { ForwardRef as ReactComponent };